<template>
  <div class="answer-modal" :class="{'answer-modal--with-sidebar': isShowAbsenceSidebar}">
  <DModal :show-close="false" :isBgOverlay="true" :placeInTop="true" @close="$emit('close')">
    <div class="d-modal" slot="insertComponent" :class="{'d-modal--with-opus': isShowSalaryInfoBox}">
      <div class="d-modal__header">
        <h2>{{ i18n['answer_absence_request'] }}</h2>
        <div class="d-modal__header-actions">
          <button class="do-bttn do-bttn--small" v-if="!isShowAbsenceSidebar" @click="isShowAbsenceSidebar = true">
            {{ i18n['show_absent'] }}
          </button>
          <div class="d-modal__close icon__bg-circle" @click="$emit('close')">
            <span class="icon-cross2"></span>
          </div>
        </div>
      </div>

      <div class="d-modal__content-wrapper">
        <div class="d-modal__content">
          <table>
            <tbody>
            <tr>
              <td><b>{{ request.vUserName }}:</b></td>
              <td>{{ request.vSubjectTitle }},</td>
              <td>{{ request.vStart }} -</td>
              <td>{{ request.vEnd }}</td>
            </tr>
            <tr style="border-top: 1px solid #e2e8f0">
              <td colspan="4" class="italic">{{ request.request_note }}</td>
            </tr>
            </tbody>
          </table>
          <div class="marg-1-top">
            <label class="d-label marg-05-bottom">{{ i18n['absence_reason'] }}</label>
            <UserAbsence
                :isShowLabel="false"
                :selectedSubject="{ id: request.subject_id }"
                @setSubject="updateRequestSubject">
              </UserAbsence>
            </div>
          <div class="d-group">
            <label class="d-label">{{ i18n['date'] }}</label>
            <DatepickerRange
              :allowSameDate="true"
              :startdate="initStartDate"
              :enddate="initEndDate"
              @startchanged="setStartDate"
              @endchanged="setEndDate">
            </DatepickerRange>
          </div>

          <div class="time-changer__group">
            <label class="d-label">{{ i18n['time'] }}</label>
            <TimeChanger
              :showIcon="true"
              :start="startTime"
              :end="endTime"
              :isFiveMinutesInterval="false"
              @updateStart="setStartTime"
              @updateEnd="setEndTime">
            </TimeChanger>
          </div>
          <div class="marg-1-top">
            <label class="d-label">{{ i18n['reply_note'] }}</label>
            <textarea v-model="note" class="do-input do-textarea" v-focus></textarea>
          </div>
        </div>

        <!-- SD Info Box -->
        <div class="opus-info-box" v-if="isShowSdInfoBox">
          <div class="do-sd-badge do-opus-badge--large opus-info__header">SD</div>

          <!-- Ansættelsesnummer -->
          <div class="opus-info__field" v-if="userEmployments.length > 0">
            <label class="opus-info__label">Ansættelse</label>
            <select
              class="do-select"
              :class="{'do-select--error': showValidationErrors && !isEmploymentValid}"
              v-model="selectedEmploymentId">
              <option :value="null">— Vælg ansættelsesnummer —</option>
              <option
                v-for="employment in userEmployments"
                :key="employment.id"
                :value="employment.id">
                {{ employment.title }} - {{ employment.employment_number || employment.id }}
              </option>
            </select>
            <span class="error-message" v-if="showValidationErrors && !isEmploymentValid">
              Ansættelsesnummer skal vælges
            </span>
          </div>

          <!-- Fraværsårsag -->
          <div class="opus-info__field">
            <label class="opus-info__label">Fraværsårsag</label>
            <div class="opus-info__reason-display">
              <span class="opus-info__reason-code" v-if="getSDAbsence">
                {{ getSDAbsence.loenart }}{{ getSDAbsence.title ? ' - ' + getSDAbsence.title : '' }}
              </span>
            </div>
          </div>

          <!-- Åbenstående toggle -->
          <div class="opus-info__field" v-if="isSdOngoingAllowed">
            <label class="opus-info__label">Åbenstående</label>
            <div class="opus-info__toggle-row">
              <div class="do-opus-toggle" @click="isOngoing = !isOngoing">
                <app-toggle :prop-on="isOngoing"></app-toggle>
                <span>Indberet som åbenstående</span>
              </div>
            </div>
          </div>

          <!-- Hel dag toggle -->
          <div class="opus-info__field">
            <label class="opus-info__label">Tid</label>
            <div class="opus-info__date-text" v-if="useTime">
              {{ formatTime(startTime) }} - {{ formatTime(endTime) }}
            </div>
            <div class="opus-info__date-text" v-else>
              Hel dag
            </div>
            <div class="opus-info__toggle-row opus-info__toggle-row--secondary">
              <div class="do-opus-toggle" @click="useTime = !useTime">
                <app-toggle :prop-on="!useTime"></app-toggle>
                <span>Indberet som hel dag</span>
              </div>
            </div>
          </div>
        </div>

        <!-- OPUS Info Box -->
        <div class="opus-info-box" v-if="isShowOpusInfoBox">
          <div class="do-opus-badge do-opus-badge--large opus-info__header">Opus</div>

          <!-- Ansættelsesnummer -->
          <div class="opus-info__field" v-if="userEmployments.length > 0">
            <label class="opus-info__label">Ansættelse</label>
            <select
              class="do-select"
              :class="{'do-select--error': showValidationErrors && !isEmploymentValid}"
              v-model="selectedEmploymentId"
              @change="onEmploymentChange">
              <option :value="null">— Vælg ansættelsesnummer —</option>
              <option
                v-for="employment in userEmployments"
                :key="employment.id"
                :value="employment.id">
                {{ employment.title }} - {{ employment.employment_number || employment.id }}
              </option>
            </select>
            <span class="error-message" v-if="showValidationErrors && !isEmploymentValid">
              Ansættelsesnummer skal vælges
            </span>
          </div>

          <!-- Fraværsårsag -->
          <div class="opus-info__field">
            <label class="opus-info__label">Fraværsårsag</label>
            <div class="opus-info__reason-display">
              <span class="opus-info__reason-code" v-if="getOPUSAbsence">
                {{ getOPUSAbsence.absence_type }}{{ getOPUSAbsence.absence_type_text ? ' - ' + getOPUSAbsence.absence_type_text : '' }}
              </span>
            </div>

            <!-- Ekstra information -->
            <div v-if="isShowExtraInformation" class="opus-info__extra-info">
              <!-- Maternity -->
              <template v-if="getOPUSAbsence && getOPUSAbsence.additional_data === 'Maternity'">
                <label class="opus-info__label opus-info__label--secondary">Ekstra information til barselssager</label>
                <div class="do-spinner do-spinner--small" v-if="isLoadingAdditionalData"></div>
                <div class="opus-info__error" v-else-if="additionalDataError">
                  <span class="opus-info__error-icon">⚠</span>
                  <span>Kunne ikke hente data fra Opus</span>
                </div>
                <select class="do-select" v-model="selectedAdditionalData" v-else-if="additionalDataOptions.length > 0">
                  <option value="">— Vælg ekstra information —</option>
                  <option v-for="option in additionalDataOptions" :key="option.MaternityCaseKey" :value="option.MaternityCaseKey">
                    {{ option.ExpectedDeliveryDate }} - {{ option.MaternityCaseKey }}
                  </option>
                </select>
                <p class="opus-info__note" v-else-if="hasLoadedAdditionalData">
                  Der er ingen barselssager tilknyttet denne medarbejder i Opus.
                </p>
              </template>
              <!-- Reason -->
              <template v-if="getOPUSAbsence && getOPUSAbsence.additional_data === 'Reason'">
                <label class="opus-info__label opus-info__label--secondary">Ekstra information til tjenestefri</label>
                <div class="do-spinner do-spinner--small" v-if="isLoadingAdditionalData"></div>
                <div class="opus-info__error" v-else-if="additionalDataError">
                  <span class="opus-info__error-icon">⚠</span>
                  <span>Kunne ikke hente data fra Opus</span>
                </div>
                <select class="do-select" v-model="selectedAdditionalData" v-else-if="additionalDataOptions.length > 0">
                  <option value="">— Vælg ekstra information —</option>
                  <option v-for="option in additionalDataOptions" :key="option.ReasonCode" :value="option.ReasonCode">
                    {{ option.ReasonCodeText }} - {{ option.ReasonCode }}
                  </option>
                </select>
                <p class="opus-info__note" v-else-if="hasLoadedAdditionalData">
                  Der er ingen tjenestefri årsager tilknyttet denne medarbejder i Opus.
                </p>
              </template>
              <!-- WorkInjury -->
              <template v-if="getOPUSAbsence && getOPUSAbsence.additional_data === 'WorkInjury'">
                <label class="opus-info__label opus-info__label--secondary">Ekstra information til arbejdsskader</label>
                <div class="do-spinner do-spinner--small" v-if="isLoadingAdditionalData"></div>
                <div class="opus-info__error" v-else-if="additionalDataError">
                  <span class="opus-info__error-icon">⚠</span>
                  <span>Kunne ikke hente data fra Opus</span>
                </div>
                <select class="do-select" v-model="selectedAdditionalData" v-else-if="additionalDataOptions.length > 0">
                  <option value="">— Vælg ekstra information —</option>
                  <option v-for="option in additionalDataOptions" :key="option.AccidentNumber" :value="option.AccidentNumber">
                    {{ option.AccidentDate }} - {{ option.AccidentNumber }}
                  </option>
                </select>
                <p class="opus-info__note" v-else-if="hasLoadedAdditionalData">
                  Der er ingen arbejdsskadesager tilknyttet denne medarbejder i Opus.
                </p>
              </template>
              <!-- Child -->
              <template v-if="getOPUSAbsence && getOPUSAbsence.additional_data === 'Child'">
                <label class="opus-info__label opus-info__label--secondary">Ekstra information til omsorgsdage</label>
                <div class="do-spinner do-spinner--small" v-if="isLoadingAdditionalData"></div>
                <div class="opus-info__error" v-else-if="additionalDataError">
                  <span class="opus-info__error-icon">⚠</span>
                  <span>Kunne ikke hente data fra Opus</span>
                </div>
                <select class="do-select" v-model="selectedAdditionalData" v-else-if="additionalDataOptions.length > 0">
                  <option value="">— Vælg ekstra information —</option>
                  <option v-for="option in additionalDataOptions" :key="option.ChildNumber" :value="option.ChildNumber">
                    {{ option.FirstName }} {{ option.LastName }} - {{ option.ChildNumber }}
                  </option>
                </select>
                <p class="opus-info__note" v-else-if="hasLoadedAdditionalData">
                  Der er ingen barn tilknyttet denne medarbejder i Opus.
                </p>
              </template>
              <span class="error-message" v-if="showValidationErrors && !isAdditionalDataValid">
                Ekstra information skal vælges
              </span>
            </div>
          </div>

          <!-- Åbenstående toggle -->
          <div class="opus-info__field" v-if="isOpusAllowOpen">
            <label class="opus-info__label">Åbenstående</label>
            <div class="opus-info__toggle-row">
              <div class="do-opus-toggle" @click="isOngoing = !isOngoing">
                <app-toggle :prop-on="isOngoing"></app-toggle>
                <span>Indberet som åbenstående</span>
              </div>
            </div>
          </div>

          <!-- Hel dag toggle -->
          <div class="opus-info__field">
            <label class="opus-info__label">Tid</label>
            <div class="opus-info__date-text" v-if="useTime">
              {{ formatTime(startTime) }} - {{ formatTime(endTime) }}
            </div>
            <div class="opus-info__date-text" v-else>
              Hel dag
            </div>
            <div class="opus-info__toggle-row opus-info__toggle-row--secondary">
              <div class="do-opus-toggle" @click="useTime = !useTime">
                <app-toggle :prop-on="!useTime"></app-toggle>
                <span>Indberet som hel dag</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-modal__buttons d-modal__buttons__flex">
        <button class="do-bttn"
                @click="rejectRequest"
                :class="{'do-bttn--loading': isLoadingRejected}">
          {{ i18n['reject'] }}
        </button>
        <button class="do-bttn"
                :class="{'do-bttn--loading': isLoadingApprove}"
                @click="approveRequest">
          {{ i18n['approve'] }}
        </button>
      </div>
    </div>
  </DModal>
  <UserRequestAbsenceSidebar
    v-if="isShowAbsenceSidebar"
    :date="startDate"
    :requesterId="request.request_by_id"
    @close="isShowAbsenceSidebar = false">
  </UserRequestAbsenceSidebar>
  </div>
</template>

<script>
import docendo from '../../docendo'
import DModal from '../common/DModal.vue'
import eventbus from '../../eventbus'
import { mapGetters } from 'vuex'
import UserAbsence from './UserAbsence.vue'
import AppToggle from '../common/AppToggle.vue'
import DatepickerRange from '../datepicker/DatePickerRange.vue'
import TimeChanger from '../TimeChanger.vue'
import UserRequestAbsenceSidebar from './UserRequestAbsenceSidebar.vue'
import moment from 'moment'

const I18N = {
  da: {
    answer_absence_request: 'Besvar fraværsanmodning',
    absence_reason: 'Fraværsårsag',
    date: 'Dato',
    time: 'Tid',
    reply_note: 'Note til besvarelsen',
    reject: 'Afvis',
    approve: 'Godkend',
    show_absent: 'Vis fraværende',
    toast_updated: 'Fraværsanmodning opdateret'
  },
  en: {
    answer_absence_request: 'Answer absence request',
    absence_reason: 'Absence reason',
    date: 'Date',
    time: 'Time',
    reply_note: 'Reply note',
    reject: 'Reject',
    approve: 'Approve',
    show_absent: 'Show absent',
    toast_updated: 'Absence request updated'
  },
  nb: {
    answer_absence_request: 'Svar på fraværsforespørsel',
    absence_reason: 'Fraværsårsak',
    date: 'Dato',
    time: 'Tid',
    reply_note: 'Svarmerknad',
    reject: 'Avvis',
    approve: 'Godkjenn',
    show_absent: 'Vis fraværende',
    toast_updated: 'Fraværsforespørsel oppdatert'
  }
}

export default {
  components: { DModal, UserAbsence, AppToggle, DatepickerRange, TimeChanger, UserRequestAbsenceSidebar },
  props: {
    request: {
      default: null
    }
  },
  data () {
    return {
      note: '',
      isLoadingApprove: false,
      isLoadingRejected: false,
      subjectId: null,
      useTime: false,
      useTimeBeforeTimeEdit: false,
      wholeDayToastTimer: null,
      initStartDate: moment(),
      initEndDate: moment(),
      startDate: moment(),
      endDate: moment(),
      startTime: moment().set({ hour: 8, minutes: 0 }),
      endTime: moment().set({ hour: 16, minutes: 0 }),
      isOngoing: false,
      isShowAbsenceSidebar: window.innerWidth > 760,
      selectedEmploymentId: null,
      selectedAdditionalData: '',
      opusAbsenceCodes: [],
      sdAbsenceCodes: [],
      additionalDataOptions: [],
      additionalDataError: null,
      isLoadingAdditionalData: false,
      hasLoadedAdditionalData: false,
      absenceSubjects: [],
      showValidationErrors: false
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
        el.select()
      }
    }
  },
  computed: {
    ...mapGetters([
      'schoolId',
      'locale',
      'employmentsInUserIdHash'
    ]),
    selectedSubject () {
      return this.subjectId ? this.absenceSubjects.find(subject => subject.id === this.subjectId) || null : null
    },
    i18n () {
      return I18N[this.locale] || I18N['da']
    },
    isOpusAbsenceActivated () {
      return this.$store.getters.schoolFeatures && this.$store.getters.schoolFeatures.indexOf('kmd_absence') > -1
    },
    isSDIntegrationActive () {
      return this.$store.getters.schoolFeatures && this.$store.getters.schoolFeatures.indexOf('silkeborg_data_integration') > -1
    },
    isShowOpusInfoBox () {
      return this.isOpusAbsenceActivated && this.selectedSubject && this.selectedSubject.kmd_absence_code_id
    },
    isShowSdInfoBox () {
      return !!(this.isSDIntegrationActive && this.selectedSubject && this.selectedSubject.sd_absence_code_id)
    },
    isShowSalaryInfoBox () {
      return this.isShowOpusInfoBox || this.isShowSdInfoBox
    },
    getSDAbsence () {
      if (!this.selectedSubject || !this.selectedSubject.sd_absence_code_id) {
        return null
      }
      const sdAbsenceId = this.selectedSubject.sd_absence_code_id
      const absenceCodes = this.sdAbsenceCodes || []
      if (!Array.isArray(absenceCodes) || absenceCodes.length < 1) {
        return null
      }
      const match = absenceCodes.find(code => String(code.id) === String(sdAbsenceId))
      return match || null
    },
    isSdOngoingAllowed () {
      const endDate = moment(this.endDate).format('YYYY-MM-DD')
      const now = moment().format('YYYY-MM-DD')
      return moment(endDate).isSameOrAfter(now)
    },
    getOPUSAbsence () {
      if (!this.selectedSubject || !this.selectedSubject.kmd_absence_code_id) {
        return null
      }
      const opusAbsenceId = this.selectedSubject.kmd_absence_code_id
      const absenceCodes = this.opusAbsenceCodes || []
      if (!Array.isArray(absenceCodes) || absenceCodes.length < 1) {
        return null
      }
      const match = absenceCodes.find(code => String(code.id) === String(opusAbsenceId))
      return match || null
    },
    isOpusAllowOpen () {
      if (!this.isOpusAbsenceActivated || !this.selectedSubject || !this.selectedSubject.kmd_absence_code_id) {
        return false
      }
      const opusAbsence = this.getOPUSAbsence
      if (!opusAbsence || typeof opusAbsence.allow_open === 'undefined') {
        return false
      }
      return opusAbsence.allow_open === true
    },
    userEmployments () {
      if (!this.request || !this.request.request_by_id) {
        return []
      }
      const employments = this.employmentsInUserIdHash[this.request.request_by_id] || []
      return employments.filter(emp => emp.employment_number && String(emp.employment_number).trim() !== '')
    },
    isShowExtraInformation () {
      const opusAbsence = this.getOPUSAbsence
      if (!opusAbsence || !opusAbsence.additional_data) { // Når vi skal have årsager på Tjenestetid
        return false
      }
      return this.selectedEmploymentId !== null
    },
    additionalData () {
      if (!this.isShowExtraInformation || !this.selectedAdditionalData) {
        return null
      }
      return this.selectedAdditionalData
    },
    isEmploymentValid () {
      // Hvis hverken OPUS eller SD er aktiv for årsagen, er det validt
      if (!this.isShowSalaryInfoBox) {
        return true
      }
      // Hvis der er ansættelser at vælge imellem, skal én vælges
      if (this.userEmployments.length > 0) {
        return this.selectedEmploymentId !== null
      }
      return true
    },
    isAdditionalDataValid () {
      // Hvis ekstra information ikke skal vises, er det validt
      if (!this.isShowExtraInformation) {
        return true
      }
      // Hvis der kræves additional data, skal det være valgt
      const opusAbsence = this.getOPUSAbsence
      if (opusAbsence && opusAbsence.additional_data_required) {
        return this.selectedAdditionalData !== ''
      }
      return true
    },
    isSalaryFormValid () {
      return this.isEmploymentValid && this.isAdditionalDataValid
    },
    dbEventStart () {
      const date = moment(this.startDate).format('YYYY-MM-DD')
      const time = this.startTime.locale('LT')
      return moment(date).set({
        hour: time.get('hour'),
        minutes: time.get('minutes')
      })
    },
    dbEventEnd () {
      const date = moment(this.endDate).format('YYYY-MM-DD')
      const time = this.endTime.locale('LT')
      return moment(date).set({
        hour: time.get('hour'),
        minutes: time.get('minutes')
      })
    }
  },
  watch: {
    request: {
      immediate: true,
      handler (val) {
        if (val) {
          this.startDate = moment(val.start_time)
          this.endDate = moment(val.end_time)
          this.initStartDate = moment(val.start_time)
          this.initEndDate = moment(val.end_time)
          this.startTime = moment(val.start_time)
          this.endTime = moment(val.end_time)
        }
      }
    },
    selectedSubject (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.resetOpusFields()
        this.autoSelectSingleEmployment()
        if (oldValue) {
          this.isOngoing = !!(newValue && newValue.default_ongoing && (this.isOpusAllowOpen || (this.isShowSdInfoBox && this.isSdOngoingAllowed)))
        }
      }
    },
    isShowExtraInformation (newValue) {
      if (newValue) {
        this.fetchAdditionalDataForAbsence()
      } else {
        this.additionalDataOptions = []
        this.selectedAdditionalData = ''
        this.hasLoadedAdditionalData = false
        this.additionalDataError = null
      }
    },
    employmentsInUserIdHash () {
      this.autoSelectSingleEmployment()
    }
  },
  methods: {
    approveRequest () {
      // Valider OPUS/SD-felter hvis relevant
      if (!this.isSalaryFormValid) {
        this.showValidationErrors = true
        return
      }
      this.showValidationErrors = false
      this.isLoadingApprove = true
      const schoolId = this.request.school_id
      const id = this.request.id
      const responseNote = this.note
      const internalNote = ''
      const employmentId = this.selectedEmploymentId
      const useTime = this.useTime
      const additionalData = this.additionalData
      const ongoing = (this.isOpusAllowOpen || (this.isShowSdInfoBox && this.isSdOngoingAllowed)) && this.isOngoing
      const startTime = this.dbEventStart
      const endTime = this.dbEventEnd
      docendo.approveRequest(schoolId, id, responseNote, this.subjectId, internalNote, employmentId, useTime, additionalData, ongoing, startTime, endTime, response => {
        // Tjek for fejl i svaret
        if (response && response.success === false) {
          const errorMessage = (response.data && response.data.error) || response.error || 'Der opstod en fejl ved godkendelse'
          this.showToast(errorMessage, false)
          this.isLoadingApprove = false
          return
        }
        this.requestDone(response)
      }, error => {
        const errorMessage = (error && error.data && error.data.error) || (error && error.error) || 'Der opstod en fejl ved godkendelse'
        this.showToast(errorMessage, false)
        this.isLoadingApprove = false
      })
    },
    rejectRequest () {
      this.isLoadingRejected = true
      const schoolId = this.request.school_id
      const id = this.request.id
      const responseNote = this.note
      docendo.rejectRequest(schoolId, id, responseNote, success => {
        this.requestDone(success)
      }, failure => {
        this.requestDone()
      })
    },
    requestDone (resp) {
      this.isLoadingApprove = false
      this.isLoadingRejected = false
      if (resp && resp.status === 'error') {
        this.showToast(resp.message, false)
      } else {
        this.$emit('close')
      }
      this.$emit('submitted')
    },
    showToast (message, success) {
      eventbus.toast = { text: message, success }
    },
    formatTime (dateTime) {
      return moment(dateTime).format('HH:mm')
    },
    updateRequestSubject (subject) {
      this.subjectId = subject.id
    },
    setStartDate (payload) {
      this.startDate = payload
    },
    setEndDate (payload) {
      const newEnd = moment(payload).format('YYYY-MM-DD')
      const previousEnd = this.endDate ? moment(this.endDate).format('YYYY-MM-DD') : null
      this.endDate = payload
      const now = moment().format('YYYY-MM-DD')
      if (previousEnd && newEnd !== previousEnd && !moment(newEnd).isAfter(now)) {
        this.isOngoing = false
      }
    },
    setStartTime (payload) {
      this.startTime = payload
      this.syncWholeDayWithStandardTimes()
    },
    setEndTime (payload) {
      this.endTime = payload
      this.syncWholeDayWithStandardTimes()
    },
    syncWholeDayWithStandardTimes () {
      const userSettings = this.$store.state.userSettings
      const saved = userSettings && userSettings.subSettingsCreateTime
      const standardStart = saved ? moment(saved.start).format('HH:mm') : '08:00'
      const standardEnd = saved ? moment(saved.end).format('HH:mm') : '16:00'
      const isStandardStart = moment(this.startTime).format('HH:mm') === standardStart
      const isStandardEnd = moment(this.endTime).format('HH:mm') === standardEnd
      if (this.wholeDayToastTimer === null) {
        this.useTimeBeforeTimeEdit = this.useTime
      }
      this.useTime = !(isStandardStart && isStandardEnd)
      this.notifyWholeDayChange()
    },
    notifyWholeDayChange () {
      clearTimeout(this.wholeDayToastTimer)
      this.wholeDayToastTimer = setTimeout(() => {
        this.wholeDayToastTimer = null
        if (this.isShowSalaryInfoBox && this.useTime !== this.useTimeBeforeTimeEdit) {
          eventbus.toast = {text: this.useTime ? '"Indberet som hel dag" er slået fra' : '"Indberet som hel dag" er slået til', success: true}
        }
      }, 800)
    },
    onEmploymentChange () {
      // Reset additional data when employment changes
      this.selectedAdditionalData = ''
      this.additionalDataOptions = []
      this.hasLoadedAdditionalData = false
      this.additionalDataError = null
      // Hent nye additional data hvis påkrævet
      this.$nextTick(() => {
        if (this.isShowExtraInformation) {
          this.fetchAdditionalDataForAbsence()
        }
      })
    },
    autoSelectSingleEmployment () {
      if (!this.isShowSalaryInfoBox) {
        return
      }
      const employments = this.userEmployments
      if (employments.length === 1 && !this.selectedEmploymentId) {
        this.selectedEmploymentId = employments[0].id
      }
    },
    resetOpusFields () {
      this.useTime = false
      this.isOngoing = false
      this.selectedEmploymentId = null
      this.additionalDataOptions = []
      this.selectedAdditionalData = ''
      this.hasLoadedAdditionalData = false
      this.additionalDataError = null
    },
    listKmdOpusAbsenceCodes () {
      docendo.listKmdOpusAbsenceCodes(this.schoolId, success => {
        this.opusAbsenceCodes = Array.isArray(success) ? success : []
      }, failure => {
        this.opusAbsenceCodes = []
      })
    },
    listSdAbsenceCodes () {
      docendo.listSilkeborgDataAbsenceCodes(this.schoolId, success => {
        this.sdAbsenceCodes = Array.isArray(success) ? success : (success && Array.isArray(success.data) ? success.data : [])
      }, failure => {
        this.sdAbsenceCodes = []
      })
    },
    fetchAdditionalDataForAbsence () {
      if (!this.isShowExtraInformation) {
        this.additionalDataOptions = []
        this.selectedAdditionalData = ''
        return
      }
      const opusAbsence = this.getOPUSAbsence
      if (!opusAbsence) return
      if (!this.selectedEmploymentId) return

      this.isLoadingAdditionalData = true
      this.hasLoadedAdditionalData = false
      this.additionalDataOptions = []
      this.selectedAdditionalData = ''

      docendo.listAdditionalDataForAbsence(
        this.schoolId,
        this.selectedEmploymentId,
        opusAbsence.id,
        moment(this.startDate).format('YYYY-MM-DD'),
        moment(this.endDate).format('YYYY-MM-DD'),
        response => {
          // Tjek for fejl i svaret
          if (response && response.success === false) {
            this.additionalDataOptions = []
            this.additionalDataError = (response.data && response.data.error) || response.error || 'Der opstod en fejl'
            this.isLoadingAdditionalData = false
            this.hasLoadedAdditionalData = true
            return
          }
          if (response && response.error) {
            this.additionalDataOptions = []
            this.additionalDataError = response.error
            this.isLoadingAdditionalData = false
            this.hasLoadedAdditionalData = true
            return
          }
          if (response && response.data && response.data.error) {
            this.additionalDataOptions = []
            this.additionalDataError = response.data.error
            this.isLoadingAdditionalData = false
            this.hasLoadedAdditionalData = true
            return
          }
          this.additionalDataError = null
          // Parse response.response hvis det er en JSON-streng
          let parsedData = response
          if (response && response.response && typeof response.response === 'string') {
            try {
              parsedData = JSON.parse(response.response)
            } catch (e) {
              console.error('Failed to parse response.response', e)
            }
          }
          let cases = null
          if (parsedData && parsedData.Body) {
            if (opusAbsence.additional_data === 'Maternity') {
              cases = parsedData.Body.GetMaternityCasesResponse_MT && parsedData.Body.GetMaternityCasesResponse_MT.MaternityCase
            } else if (opusAbsence.additional_data === 'Reason') {
              const reasonsResponse = parsedData.Body.GetReasonsResponse_MT || parsedData.Body.GetReasonsResponse_RT
              cases = reasonsResponse && reasonsResponse.Reason
            } else if (opusAbsence.additional_data === 'WorkInjury') {
              cases = parsedData.Body.GetWorkAccidentCasesResponse_MT && parsedData.Body.GetWorkAccidentCasesResponse_MT.AccidentCase
            } else if (opusAbsence.additional_data === 'Child') {
              cases = parsedData.Body.GetChildrenResponse_MT && parsedData.Body.GetChildrenResponse_MT.Child
            }
          }
          // Håndter forskellige response formater: array, objekt med Item, eller direkte objekt
          if (Array.isArray(cases)) {
            this.additionalDataOptions = cases
          } else if (cases && cases.Item) {
            // Hvis data er wrappet i Item (enkelt element)
            this.additionalDataOptions = Array.isArray(cases.Item) ? cases.Item : [cases.Item]
          } else if (cases && typeof cases === 'object') {
            this.additionalDataOptions = [cases]
          } else {
            this.additionalDataOptions = []
          }
          // Auto-vælg hvis der kun er ét resultat
          if (this.additionalDataOptions.length === 1) {
            var singleOption = this.additionalDataOptions[0]
            var additionalDataType = opusAbsence.additional_data
            if (additionalDataType === 'Maternity' && singleOption.MaternityCaseKey) {
              this.selectedAdditionalData = singleOption.MaternityCaseKey
            } else if (additionalDataType === 'Reason' && singleOption.ReasonCode) {
              this.selectedAdditionalData = singleOption.ReasonCode
            } else if (additionalDataType === 'WorkInjury' && singleOption.AccidentNumber) {
              this.selectedAdditionalData = singleOption.AccidentNumber
            } else if (additionalDataType === 'Child' && singleOption.ChildNumber) {
              this.selectedAdditionalData = singleOption.ChildNumber
            }
          }
          this.isLoadingAdditionalData = false
          this.hasLoadedAdditionalData = true
        },
        error => {
          this.additionalDataOptions = []
          if (error && error.data && error.data.error) {
            this.additionalDataError = error.data.error
          } else if (error && error.error) {
            this.additionalDataError = error.error
          } else {
            this.additionalDataError = 'Der opstod en fejl ved hentning af data'
          }
          this.isLoadingAdditionalData = false
          this.hasLoadedAdditionalData = true
        }
      )
    },
    readSubjects () {
      docendo.schoolAbsenceSubjectsList(this.schoolId, false, success => {
        this.absenceSubjects = success
      }, failure => {
        console.log('something went wrong')
      })
    }
  },
  mounted () {
    this.readSubjects()
    this.subjectId = this.request.subject_id
    if (this.isOpusAbsenceActivated || this.isSDIntegrationActive) {
      this.$store.dispatch('readEmployments')
    }
    if (this.isOpusAbsenceActivated) {
      this.listKmdOpusAbsenceCodes()
    }
    if (this.isSDIntegrationActive) {
      this.listSdAbsenceCodes()
    }
  }
}
</script>

<style scoped>

/* Modalen ligger i wrapperens flex-flow (i stedet for absolut), så den
   centreres i pladsen ved siden af fraværspanelet og kan scrolles. */
.d-modal {
  width: 650px;
  max-width: 100%;
  border-radius: 16px;
  position: relative;
}

.d-modal--with-opus {
  width: 900px;
}

.d-modal__header-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.d-modal__content-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.d-modal__content {
  flex: 1000 1 380px;
  min-width: 0;
}

.d-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.d-modal__header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
}

.d-modal__buttons {
  display: flex;
  gap: 0.5rem;
  padding: 1rem;
  border-top: 1px solid #d8d8d8;
  margin: 0;
}

.d-modal__buttons__flex > .do-bttn {
  flex: 1;
}

.do-textarea {
  min-height: 100px;
  margin-top: 0.5rem;
}

.marg-05-bottom {
  margin-bottom: 0.5rem;
}

/* OPUS Info Box Styles */
.opus-info-box {
  background-color: #fefce8;
  flex: 1 0 280px;
  box-sizing: border-box;
  padding: 1.5rem 1rem;
  border-left: 1px solid #facc17;
  position: relative;
}

.opus-info__header {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

.opus-info__field {
  margin-bottom: 1rem;
}

.opus-info__label {
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  color: #92400e;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  margin-bottom: 0.5rem;
}

.opus-info__label--secondary {
  font-size: 0.6875rem;
  margin-bottom: 0.375rem;
}

.opus-info__reason-display {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.opus-info__reason-code {
  font-size: 0.75rem;
  color: #92400e;
}

.opus-info__extra-info {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px dashed #fde047;
}

.opus-info__error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8125rem;
  color: #dc2626;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 4px;
  padding: 0.5rem 0.75rem;
}

.opus-info__error-icon {
  font-size: 1rem;
}

.opus-info__note {
  font-size: 0.875rem;
  color: #92400e;
  font-style: italic;
  margin: 0;
}

.opus-info__toggle-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.opus-info__toggle-row--secondary {
  margin-top: 0.5rem;
}

.opus-info__date-text {
  font-size: 0.875rem;
  color: #78350f;
  margin-bottom: 0.5rem;
}

.do-opus-toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  padding: 0.25rem 1rem;
  border-radius: 4px;
  flex-direction: row-reverse;
  justify-content: space-between;
  width: 100%;
  box-shadow: 0 0 0 0 transparent, 0 0 0 0 transparent, 0 1px 1px 0 rgba(0, 0, 0, .12), 0 0 0 1px rgba(64, 68, 82, .16), 0 0 0 0 transparent, 0 0 0 0 transparent, 0 2px 5px 0 rgba(64, 68, 82, .08);
  background: #fff;
}

.do-opus-toggle span {
  font-size: 0.875rem;
  color: #78350f;
}

.do-opus-badge {
  display: inline-flex;
  font-weight: 400;
  border: 1px solid #facc17;
  border-radius: 4px;
  background-color: #fefce8;
  padding: 3px 4px;
  font-size: 9px;
  line-height: 1.5;
  color: #a26206;
}

.do-opus-badge--large {
  font-size: 11px;
  padding: 4px 8px;
}

.do-sd-badge {
  display: inline-flex;
  font-weight: 400;
  border: 1px solid #facc17;
  border-radius: 4px;
  background-color: #fefce8;
  padding: 3px 4px;
  font-size: 9px;
  line-height: 1.5;
  color: #a26206;
}

.do-select {
  width: 100%;
}

.do-select--error {
  border-color: #dc2626;
}

.error-message {
  color: #dc2626;
  font-size: 0.75rem;
  margin-top: 0.25rem;
  display: block;
}
</style>

<!-- Unscoped: vue-loader 9 understøtter ikke >>>, og reglerne skal ramme DModal-elementer.
     !important er nødvendigt for at slå DModals scoped (absolutte) placering. -->
<style>
.answer-modal .modal-wrapper {
  align-items: flex-start !important;
  justify-content: flex-start !important;
  padding: 2rem 1rem 2rem 5rem !important;
  box-sizing: border-box;
  overflow-y: auto;
}

.answer-modal .modal-wrapper .modal {
  position: relative !important;
  top: 0 !important;
  min-width: 0;
  max-width: 100%;
  margin: 0;
}

.answer-modal .modal-wrapper > .bg-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.answer-modal--with-sidebar .modal-wrapper {
  padding-right: calc(350px + 1rem) !important;
}

.answer-modal .datepickerrange {
  min-width: 0 !important;
}

@media (max-width: 1100px) {
  .answer-modal--with-sidebar .modal-wrapper {
    padding-right: calc(300px + 1rem) !important;
  }
}

@media (max-width: 760px) {
  .answer-modal .modal-wrapper {
    padding-left: 1rem !important;
  }

  .answer-modal--with-sidebar .modal-wrapper {
    padding-right: 1rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// UserRequestListAnswer.vue?6bb9faf2